import React from 'react';
import './NotFound.css';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="nf-page">
            <div className="nf-container">

                {/* Big 404 */}
                <div className="nf-code">
                    <span>4</span>
                    <span className="nf-zero">
                        <i className="fa-solid fa-gear nf-gear"></i>
                    </span>
                    <span>4</span>
                </div>

                <h1 className="nf-title">Page Not Found</h1>
                <p className="nf-desc">
                    Looks like this page took a wrong turn. The link may be broken,
                    or the page may have been moved or removed.
                </p>

                <div className="nf-actions">
                    <Link to="/" className="nf-btn-primary">
                        <i className="fa-solid fa-house"></i> Go to Home
                    </Link>
                    <a
                        href="https://api.whatsapp.com/send?phone=917011969546&text=Hi, I was browsing Partsklik and needed your support!"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nf-btn-secondary"
                    >
                        <i className="fa-brands fa-whatsapp"></i> Contact Support
                    </a>
                </div>

                <div className="nf-links">
                    <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                    <span>·</span>
                    <a href="https://turbowale.com" target="_blank" rel="noopener noreferrer">Turbowale</a>
                    <span>·</span>
                    <a href="https://germanpurje.com" target="_blank" rel="noopener noreferrer">German Purje</a>
                </div>

            </div>
        </div>
    );
};

export default NotFound;